import { Button, Tooltip } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLoanApplicationPdf } from "../mutations/@relationships/use-loan-application-pdf";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useState } from "react";
import NewWindow from "react-new-window";
import { useSignedUrl } from "modules/documents/mutations/use-signed-url";

interface DownloadLoanApplicationButtonProps {
  loanId?: string;
}

export function DownloadLoanApplicationButton({ loanId }: DownloadLoanApplicationButtonProps) {
  const { user } = useTenant();
  const { mutateAsync: generateLoanApplicationPdf, isPending: isGeneratingLoanApplicationPdf } =
    useLoanApplicationPdf();
  const [downloadUrl, setDownloadUrl] = useState<string>();
  const { mutateAsync: fetchUrl, isPending: isFetchingUrl } = useSignedUrl();

  if (!loanId || user.type !== "lender") {
    return null;
  }

  const handleDownload = async () => {
    const { id } = await generateLoanApplicationPdf(loanId);
    const url = await fetchUrl(id);
    setDownloadUrl(url);
  };

  return (
    <>
      {downloadUrl && <NewWindow url={downloadUrl} onUnload={() => setDownloadUrl(undefined)} />}
      <Tooltip
        label="Click to refresh and download the latest Term Sheet PDF"
        placement="auto"
        hasArrow
      >
        <Button
          variant="white"
          size="sm"
          gap={2}
          onClick={handleDownload}
          isLoading={isGeneratingLoanApplicationPdf || isFetchingUrl}
        >
          <FontAwesomeIcon icon={["fas", "arrows-rotate"]} />
          Term Sheet PDF
        </Button>
      </Tooltip>
    </>
  );
}
